<template>
  <!--
    そのプロジェクトの所属メンバーが使える打刻場所（見るだけ）。

    どこから見えるか：プロジェクト → プロジェクト詳細 → 画面の下のほう。
    場所の追加・変更は、自社設定の「打刻場所の登録」1か所だけで行う。

    位置情報記録を使っていない会社で、場所も1件も無いときは、欄そのものを出さない。
    読めなかったとき（権限が無い・通信の失敗）も出さない。プロジェクト詳細の本体には響かせない。
  -->
  <section v-if="visible" class="project-stamping-places" data-testid="project-stamping-places">
    <h3>{{ T.projectTitle }}</h3>
    <p class="project-stamping-places__lead">{{ T.projectDescription }}</p>

    <p v-if="!places.length" class="project-stamping-places__lead" data-testid="project-stamping-places-empty">{{ T.projectEmpty }}</p>
    <div v-else class="project-stamping-places__table">
      <table>
        <thead>
          <tr>
            <th>{{ T.columnName }}</th>
            <th>{{ T.columnAddress }}</th>
            <th>{{ T.columnRadius }}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="place in places" :key="place.id" :data-testid="'project-stamping-place-' + place.id">
            <td>{{ place.name }}</td>
            <td>
              {{ addressOf(place) }}
              <a :href="mapUrl(place)" target="_blank" rel="noopener noreferrer">地図を表示</a>
            </td>
            <td>{{ place.radius_m }}m</td>
          </tr>
        </tbody>
      </table>
    </div>
  </section>
</template>

<script>
import axios from 'axios'
import T from '@/setting/stampingPlaceTexts'
import { stampPlaceName } from '@/utils/stampPlaceName'

export default {
  name: 'ProjectStampingPlaces',

  props: {
    projectId: { type: [Number, String], default: null }
  },

  data () {
    return { T, loaded: false, locationEnabled: false, places: [], addresses: {} }
  },

  computed: {
    visible () {
      return this.loaded && (this.locationEnabled || this.places.length > 0)
    }
  },

  watch: {
    projectId: { immediate: true, handler () { this.load() } }
  },

  methods: {
    load () {
      this.loaded = false
      if (this.projectId == null || this.projectId === '') return Promise.resolve()
      const asked = this.projectId
      return axios.get(process.env.VUE_APP_API_ORIGIN + '/project/' + asked + '/stamping-places')
        .then(response => {
          if (asked !== this.projectId) return
          const data = (response && response.data) || {}
          this.places = Array.isArray(data.places) ? data.places : []
          this.locationEnabled = data.location_enabled === true
          this.loaded = true
          this.places.forEach(place => {
            const key = this.keyOf(place)
            if (Object.prototype.hasOwnProperty.call(this.addresses, key)) return
            stampPlaceName(place.latitude, place.longitude)
              .then(name => { this.$set(this.addresses, key, name || '') })
          })
        })
        .catch(() => { this.loaded = false })
    },
    keyOf (place) {
      return place.latitude + ',' + place.longitude
    },
    addressOf (place) {
      const name = this.addresses[this.keyOf(place)]
      return name ? name + ' 付近' : ''
    },
    mapUrl (place) {
      return 'https://www.google.com/maps?q=' + Number(place.latitude) + ',' + Number(place.longitude)
    }
  }
}
</script>

<style scoped>
.project-stamping-places {
  margin-top: 1.5rem;
  padding-top: 1.25rem;
  border-top: 1px solid #d8dbe0;
}
.project-stamping-places h3 {
  font-size: 1rem;
  font-weight: 700;
}
.project-stamping-places__lead {
  color: #5c6873;
}
.project-stamping-places__table {
  overflow-x: auto;
}
.project-stamping-places__table table {
  width: 100%;
  border-collapse: collapse;
}
.project-stamping-places__table th,
.project-stamping-places__table td {
  padding: 0.4rem 0.6rem;
  border-bottom: 1px solid #e4e7ea;
  text-align: left;
}
</style>
